// Language translations for Betera Training Center
export const translations = {
  en: {
    // Authentication
    welcome_back: "Your personal training portal",
    join_betera: "Join Betera Training",
    start_transformation: "Start your fitness transformation today",
    sign_in: "Sign In",
    sign_up: "Sign up here",
    create_account: "Create Account",
    already_have_account: "Already have an account?",
    dont_have_account: "Don't have an account?",
    email: "Email",
    password: "Password",
    full_name: "Full Name",
    phone: "Phone",
    role: "I am a",
    administrator: "Administrator",
    trainer: "Trainer",
    client: "Client",
    admin_panel: "Admin Panel",
    manage_trainers: "Manage Trainers",
    manage_all_users: "Manage All Users",
    system_statistics: "System Statistics",
    audit_logs: "Audit Logs",
    deactivate: "Deactivate",
    activate: "Activate",
    total_users: "Total Users",
    total_workouts: "Total Workouts",
    completed_workouts: "Completed Workouts",
    recent_activity: "Recent Activity (7 days)",
    action: "Action",
    timestamp: "Timestamp",
    user: "User",
    details: "Details",
    new_users: "New Users",
    new_workouts: "New Workouts",
    actions: "Actions",
    status: "Status",
    
    // Dashboard
    welcome: "Welcome",
    logout: "Logout",
    overview: "Overview",
    book_session: "Book Session",
    my_bookings: "My Bookings",
    my_sessions: "My Sessions",
    workouts: "Workouts",
    my_workouts: "My Workouts",
    create_workout: "Create Workout",
    active_workout: "Active Workout",
    edit_workout: "Edit Workout",
    no_exercises_in_workout: "No exercises in this workout",
    add_notes: "Add notes (optional)",
    schedule: "Schedule",
    calendar: "Calendar",
    bookings: "Bookings",
    clients: "Clients",
    exercises: "Exercises",
    training_metrics: "Training Metrics",
    profile: "Profile",
    templates: "Templates",
    sessions: "Sessions",
    latest_activity: "Latest Activity",
    calendar_bookings: "Calendar & Bookings",
    start_workout: "Start Workout",
    metrics: "Metrics",
    calendar_activities: "Calendar & Activities",
    book_session: "Book Session",
    my_bookings: "My Bookings",
    log_external_activity: "Log External Activity",
    previous: "Previous",
    next: "Next",
    
    // Stats
    total_bookings: "Total Bookings",
    completed_workouts: "Completed Workouts",
    this_month: "This Month",
    total_clients: "Total Clients",
    pending_bookings: "Pending Bookings",
    available_slots: "Available Slots",
    
    // Booking
    book_a_session: "Book a Session",
    spots_available: "spots available",
    confirm_booking: "Confirm Booking",
    cancel: "Cancel",
    notes_for_trainer: "Notes for trainer (optional)",
    booking_request_sent: "Booking request sent successfully! Your booking is pending trainer approval.",
    check_bookings: "Check \"My Bookings\" to see the status.",
    reschedule: "Reschedule",
    reschedule_booking: "Reschedule Booking",
    current_booking: "Current Booking",
    select_new_slot: "Select a new time slot",
    select_this_slot: "Select this slot",
    
    // Workout Tracking
    start_workout: "Start Workout",
    current_exercise: "Current Exercise",
    set: "Set",
    reps: "Reps",
    weight: "Weight",
    rate_this_exercise: "Rate this exercise",
    mark_as_favorite: "Mark as favorite",
    mark_as_dislike: "Mark as dislike",
    favorite: "Favorite",
    dislike: "Dislike",
    workout_complete: "Workout Complete",
    rate_your_session: "How was your session?",
    tap_to_rate: "Tap a number to rate (1=Poor, 10=Amazing)",
    poor_session: "Could be better",
    okay_session: "Decent workout",
    good_session: "Great workout",
    amazing_session: "Outstanding",
    your_exercise_feedback: "Your Exercise Feedback",
    no_feedback_given: "No feedback given",
    please_rate_session: "Please rate your session (1-10)",
    submit_finish_workout: "Submit & Finish Workout",
    rest_time: "Rest Time",
    rpe: "RPE (1-10)",
    complete_set: "Complete Set",
    next_exercise: "Next Exercise",
    finish_workout: "Finish Workout",
    workout_completed: "Workout Completed!",
    view_summary: "View Summary",
    back_to_workouts: "Back to Workouts",
    workout_summary: "Workout Summary",
    date: "Date",
    total_time: "Total Time",
    effective_training: "Effective Training",
    exercises_completed: "Exercises Completed",
    no_workouts_yet: "No Workouts Yet",
    trainer_will_create: "Your trainer will create workouts for you after approving your booking sessions.",
    workout: "Workout",
    scheduled: "Scheduled",
    planned: "Planned",
    in_progress: "In Progress",
    completed_status: "Completed",
    no_workout: "No workout",
    select_exercise: "Select Exercise",
    add_to_workout: "Add",
    just_added: "Added",
    showing_limited: "Showing 60 of",
    exercises_use_filters: "exercises. Use filters to narrow down.",
    last_used_label: "Last",
    no_exercises_added: "No exercises added yet. Your trainer will add exercises to this workout.",
    min: "min",
    kg: "kg",
    
    // Exercise Management
    exercise_library: "Exercise Library",
    add_exercise: "Add Exercise",
    edit_exercise: "Edit Exercise",
    exercise_name: "Exercise Name",
    category: "Category",
    equipment: "Equipment",
    instructions: "Instructions",
    instructions_spanish: "Instructions (Spanish)",
    load_complete_database: "Load Complete Exercise Database",
    search_exercises: "Search exercises...",
    search_by_name: "Search by Name",
    image_url: "Image URL",
    upload_image: "Upload from device",
    uploading_image: "Uploading...",
    or_label: "or",
    in_plan: "In plan",
    image_upload_failed: "Image upload failed. Try again.",
    create_exercise: "Create Exercise",
    update_exercise: "Update Exercise",
    add_exercises_from_library: "Add Exercises from Library",
    found: "Found",
    exercises_in_library: "exercises in library",
    no_exercises_found: "No exercises found matching",
    select_category: "Select category",
    view_details: "View Details",
    muscles_worked: "Muscles Worked",
    detailed_muscle_breakdown: "Detailed Muscle Breakdown",
    confirm_delete_exercise: "Are you sure you want to delete this exercise?",
    this_action_cannot_be_undone: "This action cannot be undone.",
    exercise_deleted_successfully: "Exercise deleted successfully",
    error_deleting_exercise: "Error deleting exercise",
    muscles_worked_this_session: "Muscles Worked This Session",
    target_muscles: "Target Muscles",
    synergist_muscles: "Synergist Muscles",
    stabilizer_muscles: "Stabilizer Muscles",
    all_categories: "All Categories",
    of: "of",
    exercises: "exercises",
    all_types: "All Types",
    push: "Push",
    pull: "Pull",
    full_body: "Full Body",
    stretch: "Stretch",
    carry: "Carry",
    // New normalized filter labels
    primary_muscle: "Primary Muscle",
    primary_muscles: "Primary Muscles",
    all_muscles: "All Muscles",
    all_equipment: "All Equipment",
    all_difficulties: "All Difficulties",
    repeat_weekly: "Repeat Weekly",
    no_repeat: "No repeat",
    weeks: "weeks",
    months: "months",
    year: "year",
    years: "years",
    this_will_create: "This will create",
    optional: "optional",
    muscle_group: "Muscle Group",
    all_muscle_groups: "All Muscle Groups",
    clear_filters: "Clear Filters",
    without_images_only: "Without Images Only",
    duplicates_only: "Duplicates Only",
    hide_fitnessprogramer: "Hide FitnessProgramer",
    bulk_select_mode: "Bulk Select Mode",
    select_all: "Select All",
    selected: "selected",
    delete_selected: "Delete Selected",
    groups: "groups",
    of: "of",
    exercises_shown: "exercises shown",
    hidden_by_filters: "hidden by filters",
    possible_duplicate: "Possible Duplicate",
    muscle_groups: "Muscle Groups",
    comma_separated: "comma-separated",
    muscle_groups_help: "Enter muscle groups separated by commas (e.g., chest, triceps, anterior deltoid)",
    image_url_help: "Enter the direct URL to the exercise GIF or image",
    muscles: "Muscles",
    select_muscle_to_add: "Select muscle to add",
    add: "Add",
    no_muscles_selected: "No muscles selected yet. Select from dropdown to add.",
    scroll_to_top: "Scroll to top",
    view_exercise_details: "View exercise details",
    view_instructions: "View instructions",
    target: "Target",
    sets: "Sets",
    reps: "Reps",
    weight: "Weight",
    rest: "Rest",
    group: "Group",
    same_letter_same_group: "Same letter = same group",
    legend: "Legend",
    how_to_perform: "How to Perform",
    execution_steps: "Execution Steps",
    form_tips: "Form Tips",
    common_mistakes: "Common Mistakes",
    variations: "Variations",
    alternative_exercises: "Alternative Exercises",
    
    // Categories
    chest: "Chest",
    back: "Back",
    legs: "Legs",
    shoulders: "Shoulders",
    arms: "Arms",
    core: "Core",
    abs: "Abs",
    cardio: "Cardio",
    stretching: "Stretching",
    plyometrics: "Plyometrics",
    "full-body": "Full Body",
    "full body": "Full Body",
    
    // Difficulty Levels
    difficulty: "Difficulty",
    select_difficulty: "Select difficulty",
    beginner: "Beginner",
    intermediate: "Intermediate",
    advanced: "Advanced",
    
    // Status
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    completed: "Completed",
    
    // Training Metrics
    training_history: "Training History",
    progress_charts: "Progress Charts",
    volume_over_time: "Volume Over Time",
    weekly_sessions: "Weekly Sessions",
    exercise_progress: "Exercise Progress",
    favorite_exercises: "Favorite Exercises",
    achievements: "Achievements",
    total_volume: "Total Volume",
    total_duration: "Total Duration",
    average_duration: "Average Duration",
    recent_activity: "Recent Activity",
    no_training_data: "No training data available yet",
    start_training_message: "Complete some workouts to see your progress here!",
    
    // Profile
    personal_information: "Personal Information",
    name: "Name",
    age: "Age",
    years: "years",
    member_number: "Member #",
    birthday_alert: "Birthday Today!",
    physical_stats: "Physical Stats",
    height: "Height",
    bmi: "BMI",
    fitness_goals: "Fitness Goals",
    emergency_contact: "Emergency Contact",
    edit_profile: "Edit Profile",
    save_changes: "Save Changes",
    email_cannot_change: "Email cannot be changed",
    age_auto_calculated: "Age is auto-calculated from birth date",
    fitness_goals_placeholder: "e.g., Lose weight, Build muscle, Increase endurance...",
    emergency_contact_placeholder: "Name and phone number",
    not_provided: "Not provided",
    no_fitness_goals: "No fitness goals set yet",
    no_emergency_contact: "No emergency contact set",
    cancel: "Cancel",
    phone: "Phone",
    full_name: "Full Name",
    
    // Registration Questionnaire
    nationality: "Nationality",
    address: "Address",
    birth_date: "Birth Date",
    gender: "Gender",
    male: "Male",
    female: "Female",
    prefer_not_to_say: "Prefer not to say",
    weight: "Weight (kg)",
    injury_history: "Any Pathology or Important Injury?",
    referral_source: "How did you find us?",
    social_media: "Social Media",
    recommendation: "Recommendation",
    web_search: "Web Search",
    other: "Other",
    training_objectives: "Main Reason for Training / Objectives",
    postal_code: "Postal Code",
    city: "City",
    no_injuries: "No injuries recorded",
    injury_history_placeholder: "Describe any relevant injuries or conditions...",
    payment_preference: "Payment Preference",
    monthly: "Monthly",
    per_session: "Per Session",
    schedule_preferences: "Schedule Preferences",
    time_slots: "Preferred Time Slots",
    morning: "Morning",
    midday: "Midday",
    afternoon: "Afternoon",
    evening: "Evening/Night",
    preferred_days: "Preferred Days",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",
    registration_step_1: "Personal Information",
    registration_step_2: "Physical Information",
    registration_step_3: "Training Information",
    registration_step_4: "Preferences",
    continue: "Continue",
    back: "Back",
    skip: "Skip",
    optional: "optional",
    only_email_password_required: "Only email, password and name are required. You can skip the rest and fill later.",
    complete_registration: "Complete Registration",
    
    // Password Reset
    reset_password: "Reset Password",
    new_password: "New Password",
    confirm_new_password: "Confirm New Password",
    reset_password_success: "Password reset successfully",
    passwords_must_match: "Passwords must match",
    
    // External Workouts
    log_external_activity: "Log External Activity",
    activity_type: "Activity Type",
    duration: "Duration",
    minutes: "minutes",
    notes: "Notes",
    add_notes: "Add notes (optional)",
    trainer_notes: "Trainer Notes",
    log_activity: "Log Activity",
    
    // Calendar
    calendar_activities: "Calendar & Activities",
    activities: "Activities",
    external_activities: "External Activities",
    
    // Actions
    approve: "Approve",
    decline: "Decline",
    reject: "Reject",
    save: "Save",
    edit: "Edit",
    delete: "Delete",
    close: "Close",
    refresh: "Refresh",
    create: "Create",
    create_time_slot: "Create Time Slot",
    update_time_slot: "Update Time Slot",
    add: "Add",
    remove: "Remove",
    update: "Update",
    select: "Select...",
    
    // Time
    days_ago: "days ago",
    hours_ago: "hours ago",
    minutes_ago: "minutes ago",
    just_now: "Just now",
    
    // Messages
    no_data: "No data available",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    
    // Enhanced Exercise Data
    benefits: "Benefits",
    enhanced_exercise_data: "Enhanced Exercise Data (Optional)",
    target_muscles_label: "Target Muscles (comma-separated)",
    synergist_muscles_label: "Synergist Muscles (comma-separated)",
    stabilizer_muscles_label: "Stabilizer Muscles (comma-separated)",
    execution_steps_label: "Execution Steps (one per line)",
    form_tips_label: "Form Tips (one per line)",
    common_mistakes_label: "Common Mistakes (one per line)",
    benefits_label: "Benefits (one per line)",
    variations_label: "Variations (comma-separated)",
    
    // Workout Sorting & Filtering
    sort_by: "Sort By",
    filter_by_status: "Filter by Status",
    date_newest_first: "Date (Newest First)",
    date_oldest_first: "Date (Oldest First)",
    by_status: "Status",
    number_of_exercises: "Number of Exercises",
    all_workouts: "All Workouts",
    scheduled_only: "Scheduled Only",
    completed_only: "Completed Only",
    showing: "Showing",
    no_matching_workouts: "No Matching Workouts",
    try_adjusting_filters: "Try adjusting your filters to see more workouts.",
    
    // Metrics Dashboard Enhanced
    overview_tab: "Overview",
    muscles_tab: "Muscles",
    exercises_tab: "Exercises",
    muscle_group_breakdown: "Muscle Group Breakdown",
    training_distribution: "Training Distribution",
    exercise_performance_tracking: "Exercise Performance Tracking",
    latest_stats: "Latest Stats",
    no_exercise_data_period: "No exercise data available for this period.",
    last_7_days: "Last 7 days",
    last_30_days: "Last 30 days",
    last_90_days: "Last 90 days",
    last_year: "Last year",
    workouts_count: "Workouts",
    volume: "Volume",
    increase: "increase",
    sessions_tracked: "sessions tracked",
    
    // Time Metrics
    total_training_time: "Total Training Time",
    total_session_time: "Total session time",
    breaks_recovery: "Breaks & recovery",
    pure_exercise_time: "Pure exercise time",
    
    // Workout Detail Modal
    your_target: "Your Target",
    how_to_perform: "How to Perform",
    detailed_muscle_breakdown_title: "Detailed Muscle Breakdown",
    
    // Session Rating
    rate_session: "Rate Session",
    session_rating: "Session Rating",
    
    // Placeholders & Help Text
    placeholder_target_muscles: "Pectoralis Major (Sternal), Pectoralis Major (Clavicular)",
    placeholder_synergist_muscles: "Anterior Deltoid, Triceps Brachii",
    placeholder_stabilizer_muscles: "Biceps Brachii (short head), Rotator Cuff",
    placeholder_execution_steps: "Setup: Lie on a flat bench...",
    placeholder_form_tips: "Keep shoulder blades retracted",
    placeholder_common_mistakes: "Flaring elbows too wide",
    placeholder_benefits: "Builds maximal upper body pressing strength",
    placeholder_variations: "Incline Bench Press, Decline Bench Press",
    
    // Exercise Details
    no_sets_completed: "No sets completed",
    total_volume_label: "Total Volume",
    
    // Empty States
    no_workouts_message: "No Workouts Yet",
    no_data_message: "No data available",
    
    // Client Metrics
    client_metrics: "Client Metrics",
    search_client: "Search Client",
    search_by_name_email: "Search by name or email...",
    select_client: "Select Client",
    loading_metrics: "Loading metrics...",
    total_workouts: "Total Workouts",
    total_volume: "Total Volume",
    avg_duration: "Avg Duration",
    avg_rating: "Avg Rating",
    current_streak: "Current Streak",
    personal_records: "Personal Records",
    no_records_yet: "No personal records yet",
    exercise: "Exercise",
    weight: "Weight",
    reps: "Reps",
    sets: "Sets",
    volume: "Volume",
    date: "Date",
    most_trained: "Most Trained",
    no_favorites_yet: "No favorites yet",
    no_dislikes_yet: "No dislikes yet",
    injury_history: "Injury History",
    injury_type: "Injury Type",
    affected_area: "Affected Area",
    severity: "Severity",
    date_reported: "Date Reported",
    description: "Description",
    describe_injury: "Describe the injury, symptoms, and how it occurred...",
    restrictions: "Restrictions",
    no_injuries_recorded: "No injuries recorded",
    select_client_to_view_metrics: "Select a client to view their metrics",
    disliked_exercises: "Disliked Exercises",
    empty_descriptions_only: "Empty Descriptions Only",
    show_full_details: "Show Full Details",
    show_less: "Show Less",
    total: "total",
    
    // Profile Completion
    welcome: "Welcome",
    complete_profile_message: "Please complete your profile to get personalized training recommendations",
    birth_date: "Birth Date",
    gender: "Gender",
    male: "Male",
    female: "Female",
    prefer_not_to_say: "Prefer not to say",
    current_weight: "Current Weight",
    height: "Height",
    phone: "Phone",
    select_option: "Select an option",
    profile_info_usage: "This information helps us provide better training recommendations and compare your progress with similar clients.",
    complete_profile: "Complete Profile",
    saving: "Saving",
    profile_information: "Profile Information",
    age: "Age",
    years: "years",
    print_sheet: "Print Sheet",
    exercise_list: "Exercise List",
    click_to_reorder: "Click to view & reorder",
    hide: "Hide",
    drag_to_reorder_exercises: "Drag exercises to reorder if equipment is busy",
    current: "Current",
    jump_to: "Jump to",
  },
  
  es: {
    // Authentication
    welcome_back: "Tu portal de entrenamiento personal",
    join_betera: "Únete a Betera Training",
    start_transformation: "Comienza tu transformación fitness hoy",
    sign_in: "Iniciar Sesión",
    sign_up: "Regístrate aquí",
    create_account: "Crear Cuenta",
    already_have_account: "¿Ya tienes una cuenta?",
    dont_have_account: "¿No tienes una cuenta?",
    email: "Correo Electrónico",
    password: "Contraseña",
    full_name: "Nombre Completo",
    phone: "Teléfono",
    role: "Soy un",
    administrator: "Administrador",
    trainer: "Entrenador",
    client: "Cliente",
    admin_panel: "Panel de Administración",
    manage_trainers: "Gestionar Entrenadores",
    manage_all_users: "Gestionar Todos los Usuarios",
    system_statistics: "Estadísticas del Sistema",
    audit_logs: "Registro de Auditoría",
    deactivate: "Desactivar",
    activate: "Activar",
    total_users: "Total de Usuarios",
    total_workouts: "Total de Entrenamientos",
    completed_workouts: "Entrenamientos Completados",
    recent_activity: "Actividad Reciente (7 días)",
    action: "Acción",
    timestamp: "Fecha/Hora",
    user: "Usuario",
    details: "Detalles",
    new_users: "Nuevos Usuarios",
    new_workouts: "Nuevos Entrenamientos",
    actions: "Acciones",
    status: "Estado",
    
    // Dashboard
    welcome: "Bienvenido",
    logout: "Cerrar Sesión",
    overview: "Resumen",
    book_session: "Reservar Sesión",
    my_bookings: "Mis Reservas",
    my_sessions: "Mis Sesiones",
    workouts: "Entrenamientos",
    my_workouts: "Mis Entrenamientos",
    create_workout: "Crear Entrenamiento",
    active_workout: "Entrenamiento Activo",
    edit_workout: "Editar Entrenamiento",
    no_exercises_in_workout: "No hay ejercicios en este entrenamiento",
    add_notes: "Agregar notas (opcional)",
    schedule: "Horario",
    calendar: "Calendario",
    bookings: "Reservas",
    clients: "Clientes",
    exercises: "Ejercicios",
    training_metrics: "Métricas de Entrenamiento",
    profile: "Perfil",
    templates: "Plantillas",
    sessions: "Sesiones",
    latest_activity: "Última Actividad",
    calendar_bookings: "Calendario y Reservas",
    start_workout: "Comenzar Entrenamiento",
    metrics: "Métricas",
    calendar_activities: "Calendario y Actividades",
    book_session: "Reservar Sesión",
    my_bookings: "Mis Reservas",
    log_external_activity: "Registrar Actividad Externa",
    previous: "Anterior",
    next: "Siguiente",
    
    // Stats
    total_bookings: "Total de Reservas",
    completed_workouts: "Entrenamientos Completados",
    this_month: "Este Mes",
    total_clients: "Total de Clientes",
    pending_bookings: "Reservas Pendientes",
    available_slots: "Espacios Disponibles",
    
    // Booking
    book_a_session: "Reservar una Sesión",
    spots_available: "espacios disponibles",
    confirm_booking: "Confirmar Reserva",
    cancel: "Cancelar",
    notes_for_trainer: "Notas para el entrenador (opcional)",
    booking_request_sent: "¡Solicitud de reserva enviada con éxito! Tu reserva está pendiente de aprobación del entrenador.",
    check_bookings: "Consulta \"Mis Reservas\" para ver el estado.",
    reschedule: "Reprogramar",
    reschedule_booking: "Reprogramar Reserva",
    current_booking: "Reserva Actual",
    select_new_slot: "Selecciona un nuevo horario",
    select_this_slot: "Seleccionar este horario",
    
    // Workout Tracking
    start_workout: "Comenzar Entrenamiento",
    current_exercise: "Ejercicio Actual",
    set: "Serie",
    reps: "Repeticiones",
    weight: "Peso",
    rate_this_exercise: "Califica este ejercicio",
    mark_as_favorite: "Marcar como favorito",
    mark_as_dislike: "Marcar como no me gusta",
    favorite: "Favorito",
    dislike: "No me gusta",
    workout_complete: "Entrenamiento Completado",
    rate_your_session: "¿Cómo fue tu sesión?",
    tap_to_rate: "Toca un número para calificar (1=Malo, 10=Increíble)",
    poor_session: "Podría ser mejor",
    okay_session: "Entrenamiento decente",
    good_session: "Gran entrenamiento",
    amazing_session: "Excepcional",
    your_exercise_feedback: "Tu Retroalimentación de Ejercicios",
    no_feedback_given: "Sin retroalimentación",
    please_rate_session: "Por favor califica tu sesión (1-10)",
    submit_finish_workout: "Enviar y Finalizar Entrenamiento",
    rest_time: "Tiempo de Descanso",
    rpe: "RPE (1-10)",
    complete_set: "Completar Serie",
    next_exercise: "Siguiente Ejercicio",
    finish_workout: "Finalizar Entrenamiento",
    workout_completed: "¡Entrenamiento Completado!",
    view_summary: "Ver Resumen",
    back_to_workouts: "Volver a Entrenamientos",
    workout_summary: "Resumen del Entrenamiento",
    date: "Fecha",
    total_time: "Tiempo Total",
    effective_training: "Entrenamiento Efectivo",
    exercises_completed: "Ejercicios Completados",
    no_workouts_yet: "Aún No Hay Entrenamientos",
    trainer_will_create: "Tu entrenador creará entrenamientos para ti después de aprobar tus sesiones reservadas.",
    workout: "Entrenamiento",
    scheduled: "Programado",
    planned: "Planificado",
    in_progress: "En progreso",
    completed_status: "Completado",
    no_workout: "Sin entrenamiento",
    select_exercise: "Seleccionar Ejercicio",
    add_to_workout: "Agregar",
    just_added: "Agregado",
    showing_limited: "Mostrando 60 de",
    exercises_use_filters: "ejercicios. Usa los filtros para refinar.",
    last_used_label: "Ultimo",
    no_exercises_added: "Aún no se han agregado ejercicios. Tu entrenador agregará ejercicios a este entrenamiento.",
    min: "min",
    kg: "kg",
    
    // Exercise Management
    exercise_library: "Biblioteca de Ejercicios",
    add_exercise: "Agregar Ejercicio",
    edit_exercise: "Editar Ejercicio",
    exercise_name: "Nombre del Ejercicio",
    category: "Categoría",
    equipment: "Equipo",
    instructions: "Instrucciones",
    instructions_spanish: "Instrucciones (Español)",
    load_complete_database: "Cargar Base de Datos Completa",
    search_exercises: "Buscar ejercicios...",
    search_by_name: "Buscar por Nombre",
    image_url: "URL de Imagen",
    upload_image: "Subir desde dispositivo",
    uploading_image: "Subiendo...",
    or_label: "o",
    in_plan: "En el plan",
    image_upload_failed: "Error al subir la imagen. Inténtalo de nuevo.",
    create_exercise: "Crear Ejercicio",
    update_exercise: "Actualizar Ejercicio",
    add_exercises_from_library: "Agregar Ejercicios de la Biblioteca",
    found: "Encontrado",
    exercises_in_library: "ejercicios en la biblioteca",
    no_exercises_found: "No se encontraron ejercicios que coincidan con",
    select_category: "Seleccionar categoría",
    view_details: "Ver Detalles",
    muscles_worked: "Músculos Trabajados",
    detailed_muscle_breakdown: "Desglose Detallado de Músculos",
    confirm_delete_exercise: "¿Estás seguro de que quieres eliminar este ejercicio?",
    this_action_cannot_be_undone: "Esta acción no se puede deshacer.",
    exercise_deleted_successfully: "Ejercicio eliminado exitosamente",
    error_deleting_exercise: "Error al eliminar el ejercicio",
    muscles_worked_this_session: "Músculos Trabajados en Esta Sesión",
    all_categories: "Todas las Categorías",
    of: "de",
    exercises: "ejercicios",
    all_types: "Todos los Tipos",
    push: "Empuje",
    pull: "Tirón",
    full_body: "Cuerpo Completo",
    stretch: "Estiramiento",
    carry: "Acarreo",
    // New normalized filter labels
    primary_muscle: "Músculo Principal",
    primary_muscles: "Músculos Principales",
    all_muscles: "Todos los Músculos",
    all_equipment: "Todo el Equipo",
    all_difficulties: "Todas las Dificultades",
    repeat_weekly: "Repetir Semanalmente",
    no_repeat: "Sin repetir",
    weeks: "semanas",
    months: "meses",
    year: "año",
    years: "años",
    this_will_create: "Esto creará",
    optional: "opcional",
    muscle_group: "Grupo Muscular",
    all_muscle_groups: "Todos los Grupos Musculares",
    clear_filters: "Limpiar Filtros",
    without_images_only: "Solo Sin Imágenes",
    duplicates_only: "Solo Duplicados",
    hide_fitnessprogramer: "Ocultar FitnessProgramer",
    bulk_select_mode: "Modo Selección Múltiple",
    select_all: "Seleccionar Todos",
    selected: "seleccionados",
    delete_selected: "Eliminar Seleccionados",
    groups: "grupos",
    of: "de",
    exercises_shown: "ejercicios mostrados",
    hidden_by_filters: "ocultos por filtros",
    possible_duplicate: "Posible Duplicado",
    muscle_groups: "Grupos Musculares",
    comma_separated: "separados por comas",
    muscle_groups_help: "Ingresa grupos musculares separados por comas (ej: pecho, tríceps, deltoides anterior)",
    image_url_help: "Ingresa la URL directa al GIF o imagen del ejercicio",
    muscles: "Músculos",
    select_muscle_to_add: "Seleccionar músculo para agregar",
    add: "Agregar",
    no_muscles_selected: "No hay músculos seleccionados aún. Selecciona del menú desplegable para agregar.",
    scroll_to_top: "Volver arriba",
    view_exercise_details: "Ver detalles del ejercicio",
    view_instructions: "Ver instrucciones",
    target: "Objetivo",
    sets: "Series",
    reps: "Repeticiones",
    weight: "Peso",
    rest: "Descanso",
    group: "Grupo",
    same_letter_same_group: "Misma letra = mismo grupo",
    target_muscles: "Músculos Objetivo",
    synergist_muscles: "Músculos Sinergistas",
    stabilizer_muscles: "Músculos Estabilizadores",
    legend: "Leyenda",
    how_to_perform: "Cómo Realizar",
    execution_steps: "Pasos de Ejecución",
    form_tips: "Consejos de Forma",
    common_mistakes: "Errores Comunes",
    variations: "Variaciones",
    alternative_exercises: "Ejercicios Alternativos",
    
    // Categories
    chest: "Pecho",
    back: "Espalda",
    legs: "Piernas",
    shoulders: "Hombros",
    arms: "Brazos",
    core: "Core",
    abs: "Abdominales",
    cardio: "Cardio",
    stretching: "Estiramiento",
    plyometrics: "Pliométricos",
    "full-body": "Cuerpo Completo",
    "full body": "Cuerpo Completo",
    
    // Difficulty Levels
    difficulty: "Dificultad",
    select_difficulty: "Seleccionar dificultad",
    beginner: "Principiante",
    intermediate: "Intermedio",
    advanced: "Avanzado",
    
    // Status
    pending: "Pendiente",
    approved: "Aprobado",
    rejected: "Rechazado",
    completed: "Completado",
    
    // Training Metrics
    training_history: "Historial de Entrenamiento",
    progress_charts: "Gráficas de Progreso",
    volume_over_time: "Volumen a lo Largo del Tiempo",
    weekly_sessions: "Sesiones Semanales",
    exercise_progress: "Progreso de Ejercicios",
    favorite_exercises: "Ejercicios Favoritos",
    achievements: "Logros",
    total_volume: "Volumen Total",
    total_duration: "Duración Total",
    average_duration: "Duración Promedio",
    recent_activity: "Actividad Reciente",
    no_training_data: "Aún no hay datos de entrenamiento disponibles",
    start_training_message: "¡Completa algunos entrenamientos para ver tu progreso aquí!",
    
    // Profile
    personal_information: "Información Personal",
    name: "Nombre",
    age: "Edad",
    years: "años",
    member_number: "Miembro #",
    birthday_alert: "¡Cumpleaños Hoy!",
    physical_stats: "Estadísticas Físicas",
    height: "Altura",
    bmi: "IMC",
    fitness_goals: "Objetivos Fitness",
    emergency_contact: "Contacto de Emergencia",
    edit_profile: "Editar Perfil",
    save_changes: "Guardar Cambios",
    email_cannot_change: "El email no se puede cambiar",
    age_auto_calculated: "La edad se calcula automáticamente desde la fecha de nacimiento",
    fitness_goals_placeholder: "ej., Perder peso, Ganar músculo, Aumentar resistencia...",
    emergency_contact_placeholder: "Nombre y teléfono",
    not_provided: "No proporcionado",
    no_fitness_goals: "No se han establecido objetivos de fitness aún",
    no_emergency_contact: "No se ha establecido contacto de emergencia",
    cancel: "Cancelar",
    phone: "Teléfono",
    full_name: "Nombre Completo",
    
    // Registration Questionnaire
    nationality: "Nacionalidad",
    address: "Dirección",
    birth_date: "Fecha de Nacimiento",
    gender: "Género",
    male: "Hombre",
    female: "Mujer",
    prefer_not_to_say: "Prefiero no decir",
    weight: "Peso (kg)",
    injury_history: "¿Alguna Patología o Lesión Importante?",
    referral_source: "¿Cómo nos has encontrado?",
    social_media: "Redes Sociales",
    recommendation: "Recomendación",
    web_search: "Búsqueda Web",
    other: "Otro",
    training_objectives: "Motivo Principal para Entrenar / Objetivos",
    postal_code: "Código Postal",
    city: "Población",
    no_injuries: "No se han registrado lesiones",
    injury_history_placeholder: "Describe cualquier lesión o patología relevante...",
    payment_preference: "Modalidad de Pago",
    monthly: "Mensual",
    per_session: "Por Sesiones",
    schedule_preferences: "Preferencia de Horarios",
    time_slots: "Franjas Horarias Preferidas",
    morning: "Mañana",
    midday: "Medio Día",
    afternoon: "Tarde",
    evening: "Noche",
    preferred_days: "Días Preferidos",
    monday: "Lunes",
    tuesday: "Martes",
    wednesday: "Miércoles",
    thursday: "Jueves",
    friday: "Viernes",
    saturday: "Sábado",
    sunday: "Domingo",
    registration_step_1: "Información Personal",
    registration_step_2: "Información Física",
    registration_step_3: "Información de Entrenamiento",
    registration_step_4: "Preferencias",
    continue: "Continuar",
    skip: "Saltar",
    optional: "opcional",
    only_email_password_required: "Solo el email, contraseña y nombre son requeridos. Puedes saltar el resto y completarlo después.",
    complete_registration: "Completar Registro",
    
    // Password Reset
    reset_password: "Restablecer Contraseña",
    new_password: "Nueva Contraseña",
    confirm_new_password: "Confirmar Nueva Contraseña",
    reset_password_success: "Contraseña restablecida exitosamente",
    passwords_must_match: "Las contraseñas deben coincidir",
    
    // External Workouts
    log_external_activity: "Registrar Actividad Externa",
    activity_type: "Tipo de Actividad",
    duration: "Duración",
    minutes: "minutos",
    notes: "Notas",
    add_notes: "Agregar notas (opcional)",
    trainer_notes: "Notas del Entrenador",
    log_activity: "Registrar Actividad",
    
    // Calendar
    calendar_activities: "Calendario y Actividades",
    activities: "Actividades",
    external_activities: "Actividades Externas",
    
    // Actions
    approve: "Aprobar",
    decline: "Rechazar",
    reject: "Rechazar",
    save: "Guardar",
    edit: "Editar",
    delete: "Eliminar",
    close: "Cerrar",
    refresh: "Actualizar",
    create: "Crear",
    create_time_slot: "Crear Horario",
    update_time_slot: "Actualizar Horario",
    add: "Agregar",
    remove: "Eliminar",
    update: "Actualizar",
    select: "Seleccionar...",
    
    // Time
    days_ago: "hace días",
    hours_ago: "hace horas",
    minutes_ago: "hace minutos",
    just_now: "Justo ahora",
    
    // Messages
    no_data: "No hay datos disponibles",
    loading: "Cargando...",
    error: "Error",
    success: "Éxito",
    
    // Enhanced Exercise Data
    benefits: "Beneficios",
    enhanced_exercise_data: "Datos Mejorados del Ejercicio (Opcional)",
    target_muscles_label: "Músculos Objetivo (separados por comas)",
    synergist_muscles_label: "Músculos Sinergistas (separados por comas)",
    stabilizer_muscles_label: "Músculos Estabilizadores (separados por comas)",
    execution_steps_label: "Pasos de Ejecución (uno por línea)",
    form_tips_label: "Consejos de Forma (uno por línea)",
    common_mistakes_label: "Errores Comunes (uno por línea)",
    benefits_label: "Beneficios (uno por línea)",
    variations_label: "Variaciones (separadas por comas)",
    
    // Workout Sorting & Filtering
    sort_by: "Ordenar Por",
    filter_by_status: "Filtrar por Estado",
    date_newest_first: "Fecha (Más Reciente Primero)",
    date_oldest_first: "Fecha (Más Antiguo Primero)",
    by_status: "Estado",
    number_of_exercises: "Número de Ejercicios",
    all_workouts: "Todos los Entrenamientos",
    scheduled_only: "Solo Programados",
    completed_only: "Solo Completados",
    showing: "Mostrando",
    no_matching_workouts: "No Hay Entrenamientos Coincidentes",
    try_adjusting_filters: "Intenta ajustar tus filtros para ver más entrenamientos.",
    
    // Metrics Dashboard Enhanced
    overview_tab: "Resumen",
    muscles_tab: "Músculos",
    exercises_tab: "Ejercicios",
    muscle_group_breakdown: "Desglose de Grupos Musculares",
    training_distribution: "Distribución de Entrenamiento",
    exercise_performance_tracking: "Seguimiento de Rendimiento de Ejercicios",
    latest_stats: "Estadísticas Recientes",
    no_exercise_data_period: "No hay datos de ejercicios disponibles para este período.",
    last_7_days: "Últimos 7 días",
    last_30_days: "Últimos 30 días",
    last_90_days: "Últimos 90 días",
    last_year: "Último año",
    workouts_count: "Entrenamientos",
    volume: "Volumen",
    increase: "aumento",
    sessions_tracked: "sesiones rastreadas",
    
    // Time Metrics
    total_training_time: "Tiempo Total de Entrenamiento",
    total_session_time: "Tiempo total de sesión",
    breaks_recovery: "Descansos y recuperación",
    pure_exercise_time: "Tiempo puro de ejercicio",
    
    // Workout Detail Modal
    your_target: "Tu Objetivo",
    how_to_perform: "Cómo Realizar",
    detailed_muscle_breakdown_title: "Desglose Detallado de Músculos",
    
    // Session Rating
    rate_session: "Calificar Sesión",
    session_rating: "Calificación de Sesión",
    
    // Placeholders & Help Text
    placeholder_target_muscles: "Pectoral Mayor (Esternal), Pectoral Mayor (Clavicular)",
    placeholder_synergist_muscles: "Deltoides Anterior, Tríceps Braquial",
    placeholder_stabilizer_muscles: "Bíceps Braquial (cabeza corta), Manguito Rotador",
    placeholder_execution_steps: "Preparación: Acuéstate en un banco plano...",
    placeholder_form_tips: "Mantén los omóplatos retraídos",
    placeholder_common_mistakes: "Abrir demasiado los codos",
    placeholder_benefits: "Desarrolla fuerza máxima en la parte superior del cuerpo",
    placeholder_variations: "Press Inclinado, Press Declinado",
    
    // Exercise Details
    no_sets_completed: "No se completaron series",
    total_volume_label: "Volumen Total",
    
    // Empty States
    no_workouts_message: "Aún No Hay Entrenamientos",
    no_data_message: "No hay datos disponibles",
    
    // Client Metrics
    client_metrics: "Métricas del Cliente",
    search_client: "Buscar Cliente",
    search_by_name_email: "Buscar por nombre o correo...",
    select_client: "Seleccionar Cliente",
    loading_metrics: "Cargando métricas...",
    total_workouts: "Entrenamientos Totales",
    total_volume: "Volumen Total",
    avg_duration: "Duración Promedio",
    avg_rating: "Calificación Promedio",
    current_streak: "Racha Actual",
    personal_records: "Récords Personales",
    no_records_yet: "Aún no hay récords personales",
    exercise: "Ejercicio",
    weight: "Peso",
    reps: "Reps",
    sets: "Series",
    volume: "Volumen",
    date: "Fecha",
    most_trained: "Más Entrenados",
    no_favorites_yet: "Aún no hay favoritos",
    no_dislikes_yet: "Aún no hay rechazados",
    injury_history: "Historial de Lesiones",
    injury_type: "Tipo de Lesión",
    affected_area: "Área Afectada",
    severity: "Gravedad",
    date_reported: "Fecha Reportada",
    description: "Descripción",
    describe_injury: "Describe la lesión, síntomas y cómo ocurrió...",
    restrictions: "Restricciones",
    no_injuries_recorded: "No hay lesiones registradas",
    select_client_to_view_metrics: "Selecciona un cliente para ver sus métricas",
    disliked_exercises: "Ejercicios Rechazados",
    empty_descriptions_only: "Solo Descripciones Vacías",
    show_full_details: "Ver Detalles Completos",
    show_less: "Ver Menos",
    total: "total",
    
    // Profile Completion
    welcome: "Bienvenido",
    complete_profile_message: "Por favor completa tu perfil para obtener recomendaciones de entrenamiento personalizadas",
    birth_date: "Fecha de Nacimiento",
    gender: "Género",
    male: "Masculino",
    female: "Femenino",
    prefer_not_to_say: "Prefiero no decir",
    current_weight: "Peso Actual",
    height: "Altura",
    phone: "Teléfono",
    select_option: "Selecciona una opción",
    profile_info_usage: "Esta información nos ayuda a proporcionar mejores recomendaciones de entrenamiento y comparar tu progreso con clientes similares.",
    complete_profile: "Completar Perfil",
    saving: "Guardando",
    profile_information: "Información del Perfil",
    age: "Edad",
    years: "años",
    print_sheet: "Imprimir Hoja",
    exercise_list: "Lista de Ejercicios",
    click_to_reorder: "Clic para ver y reordenar",
    hide: "Ocultar",
    drag_to_reorder_exercises: "Arrastra ejercicios para reordenar si el equipo está ocupado",
    current: "Actual",
    jump_to: "Ir a",
  }
};

export const useTranslation = (language = 'en') => {
  const t = (key) => {
    return translations[language]?.[key] || translations.en[key] || key;
  };
  
  return { t };
};